import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Stomp } from '@stomp/stompjs';
import * as SockJS from 'sockjs-client';
import { SpotlightService } from 'src/app/core/services/spotlight.service';

@Component({
  selector: 'app-emoji-chart',
  templateUrl: './emoji-chart.component.html',
  styleUrls: ['./emoji-chart.component.css']
})
export class EmojiChartComponent implements OnInit {
  loveCount = 0;
  clapCount = 0;
  laughCount = 0;
  sadCount = 0;
  flushedCount = 0;
  angryCount = 0;
  @Input() id: any;
  @Input() page: any;
  @Output() parentFunction: EventEmitter<any> = new EventEmitter();
  constructor(private count: SpotlightService) {

  }

  ngOnInit(): void {
    if (this.page === 'redcarpet'){
      this.getEmojiCountData();
    }
    else if (this.page === 'theaterPage'){
      this.getTheaterEmojiCountData();
    }
    this.registerForEvent(/* [
      {
        route: `/reactions/${this.id}/${this.page}`,
        callback: (comment) => {
          const data = JSON.parse(comment.body);
          console.log('comment======>', data);

        },
      },
    ] */);
  }
  getEmojiCountData(){
    this.count.getEmojiCount(this.id).toPromise().then((res: any) => {
      this.clapCount = res.allReactions.clap || 0;
      this.laughCount = res.allReactions.laugh || 0;
      this.loveCount = res.allReactions.love || 0;
      this.sadCount  = res.allReactions.sad || 0;
      this.flushedCount = res.allReactions.flushed || 0;
      this.angryCount = res.allReactions.angry || 0;

    }).catch((err) => {
      console.log(err);
    });

  }

  getTheaterEmojiCountData(){
    this.count.getTheaterPageEmojiCount(this.id).toPromise().then((res: any) => {
      this.clapCount = res.allReactions.clap || 0;
      this.laughCount = res.allReactions.laugh || 0;
      this.loveCount = res.allReactions.love || 0;
      this.sadCount  = res.allReactions.sad || 0;
      this.flushedCount = res.allReactions.flushed || 0;
      this.angryCount = res.allReactions.angry || 0;

    }).catch((err) => {
      console.log(err);
    });
  }

  clap(){
    this.clapCount++;
    const body = {
      reaction: 'clap'
    };
    if (this.page === 'redcarpet'){
    this.count.postEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
    } else if (this.page === 'theaterPage'){
      this.count.postTheaterEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
    }
   }

  laugh(){
    this.laughCount++;
    const body = {
      reaction: 'laugh'
    };
    if (this.page === 'redcarpet'){
      this.count.postEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
      } else if (this.page === 'theaterPage'){
        this.count.postTheaterEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
      }
   }

  love(){
    this.loveCount++;
    const body = {
      reaction: 'love'
    };
    if (this.page === 'redcarpet'){
      this.count.postEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
      } else if (this.page === 'theaterPage'){
        this.count.postTheaterEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
      }
  }

  sad(){
    this.sadCount++;
    const body = {
      reaction: 'sad'
    };
    if (this.page === 'redcarpet'){
      this.count.postEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
      } else if (this.page === 'theaterPage'){
        this.count.postTheaterEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
      }
    }

  flushed(){
    this.flushedCount++;
    const body = {
      reaction: 'flushed'
    };
    if (this.page === 'redcarpet'){
      this.count.postEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
      } else if (this.page === 'theaterPage'){
        this.count.postTheaterEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
      }
    }
  angry(){
    this.angryCount++;
    const body = {
      reaction: 'angry'
    };
    if (this.page === 'redcarpet'){
      this.count.postEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
      } else if (this.page === 'theaterPage'){
        this.count.postTheaterEmojiCount(body, this.id).toPromise().then((res: any) => {console.log(res); }).catch((err) => {console.log(err); });
      }
   }

   registerForEvent(): void {
    const stompClient = Stomp.over(() => new SockJS('/event'));
    stompClient.connect({}, () => {
      console.log('inside connect');
      /* console.log('inside connection ' + registrations);
      registrations.forEach((registration) => {
        console.log('inside registration for each' + registration); */
      const destination = this.page === 'redcarpet' ? 'RED_CARPET' : 'THEATER';
      stompClient.subscribe(`/reactions/${this.id}/${destination}`, (comment) => {
          console.log('comment');
          const data = JSON.parse(comment.body);
          console.log('comment======>', data);
          try {
          this.angryCount = data.eventReactionResponse.allReactions.angry || 0;
          this.clapCount = data.eventReactionResponse.allReactions.clap || 0;
          this.flushedCount = data.eventReactionResponse.allReactions.flushed || 0;
          this.loveCount = data.eventReactionResponse.allReactions.love || 0;
          this.sadCount = data.eventReactionResponse.allReactions.sad || 0;
          this.laughCount = data.eventReactionResponse.allReactions.laugh || 0;
          } catch (e) {}
        });
      });
    /* }); */
    return;
  }
}
